import React from 'react';
import { Button } from '@material-tailwind/react';

interface DialogConfirmationProps {
    isOpen: boolean;
    title: string;
    message: string | React.ReactNode;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DialogConfirmation: React.FC<DialogConfirmationProps> = ({
    isOpen,
    title,
    message,
    onConfirm,
    onCancel
}) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onCancel();
        }
    };

    return (
        <div className="fixed inset-0 flex min-h-full text-black top-0 left-0 min-w-full z-50 items-center justify-center bg-gray-600 bg-opacity-50"
            onClick={handleBackdropClick}
        >
            <div className="bg-white p-6 rounded-md shadow-lg">
                <h3 className="text-lg font-semibold mb-4">{title}</h3>
                {typeof message === 'string' ? <p>{message}</p> : message}
                <div className="mt-4 flex gap-4 justify-center">
                    <Button
                        onClick={onCancel}
                        variant="outline"
                        color="secondary"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onConfirm}
                        color="success"
                    >
                        Confirm
                    </Button>
                </div>
            </div>
        </div>
    );
};
